import type { FunctionComponent } from 'react'
import React from 'react'
import { PadlockIcon as SBPadlockIcon } from '@which/seatbelt/src/components/Icons/Miscellaneous'

export const PadlockIcon: FunctionComponent<Props> = (props) => <SBPadlockIcon {...props} />

///////// IMPLEMENTATION /////////

type Props = Parameters<typeof SBPadlockIcon>[0]
